import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';

// const AUTH_API = 'http://localhost:3000/api/auth/';
const AUTH_API = 'https://app.farms.md/api/auth/';

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  constructor(private http: HttpClient) { }

  login(credentials): Observable<any> {
    return this.http.post(AUTH_API + 'signin', {
      username: credentials.username,
      password: credentials.password
    }, httpOptions);
  }

  register(user): Observable<any> {
    return this.http.post(AUTH_API + 'signup', {
      username: user.username,
      name: user.name + " " + user.firstname,
      lastname: user.name,
      firstname: user.firstname,
      email: user.email,
      password: user.password,
      phone: user.phone,
      region: user.region,
      roles: [user.role]
    }, httpOptions);
  }
}